<template>
    <div style="height: inherit;">
      <div v-if="loading" style="height: inherit;">
        <loading-page ref="loadingPage"></loading-page>
      </div>
      <div v-else style="height: inherit;">
        <Header :image="image"/>

        <div class="content__positioning distancing driver__terms">
          <h1 class="headlin-text">Driver terms and conditions</h1>
          <div v-html='text' class="adivi-text text"></div>
          <div class="go-back-btn">
            <button class="btn-back" @click="$router.go(-1)">
              <span class="btn__text__normal">Back</span>
            </button>
          </div>
        </div>

        <footer-view></footer-view>
      </div>
    </div>
</template>

<script>
import HTTPRequest from '../../../plugins/utils/HttpRequest.js'
// import Config from '../../../plugins/utils/Config.js'
import Header from './../../../components/design/HeaderDesign.vue'
import LoadingPage from './../../../components/loading/LoadingScreen.vue'
import FooterView from './../../../components/footer/FooterView.vue'
import toast from '@utils/toast'
export default {
  name: 'DriverTermsAndCoditions',
  data: function () {
    return {
      text: '',
      // config: Config,
      json_response: '',
      loading: true,
      image: 'ts'
    }
  },
  components: {
    Header,
    FooterView,
    LoadingPage
  },
  created: function () {
    this.makeApiCall()
  },
  methods: {
    makeApiCall () {
      var request = new HTTPRequest()
      var url = '/get/driver_terms'
      var body = {
        API_KEY: '',
        data: {
          format: 'html'
        }
      }
      request.makeRequest('POST', url, body).then((response) => {
        this.json_response = JSON.parse(response)
        if (this.json_response.code === 0){
          this.text = this.json_response.data[0].body
          setTimeout(() => {
            this.$refs.loadingPage.end()
            this.loading = false
            this.setStyle()
          }, 600)
        } else {
          toast.errorMessage(this.json_response.message)
        }
      }).catch((error) => {
        console.log(error)
        toast.errorMessage(error)
      })
    },
    setStyle () {
      setTimeout(() => {
        var element = document.getElementsByClassName('adivi-text')[0]
        element?.children?.forEach( child => {
          if (child.innerHTML.includes('<br>')){
            child.setAttribute('class', 'remove_line_height')
          }
        })
      }, 100)
    }
  },
  mounted: function () {
  }
}
</script>

<style>

.remove_line_height {
  line-height: 0;
}

</style>
